<template>
  <!-- Customers' List -->
  <div data-sidebar="chat" class="chat-sidebar-wrap" id="data-sidebar">
    <div class="border-right">
      <!-- <div class="pt-2 pb-2 pl-3 pr-3 d-flex align-items-center o-hidden box-shadow-1 chat-topbar">
        <a data-sidebar-toggle="chat" class="link-icon d-md-none">
          <i class="icon-regular ml-0 mr-3 i-Left"></i>
        </a>
        <div class="form-group m-0 flex-grow-1">
          <input
            type="text"
            class="form-control form-control-rounded"
            id="search"
            placeholder="Search contacts"
          />
        </div>
      </div> -->
      <div class="contacts-scrollable perfect-scrollbar" id="scrollbar">
        <!-- Title -->
        <div
          class="mt-4 pb-2 pl-3 pr-3 font-weight-bold text-muted border-bottom"
        >
          Customers
        </div>
        <!-- List -->
        <div
          class="p-3 d-flex align-items-center border-bottom clickable"
          v-for="(conversation, index) in conversations"
          v-bind:key="index"
          @click="selectConversation(conversation)"
        >
          <div>
            <h6 class="m-0">
              {{ conversation.customer.username }}
              <span
                class="badge badge-pill badge-danger"
                v-if="conversation.notification_count !== 0"
                style="margin-left: 2px;"
                >{{ conversation.notification_count }}</span
              >
            </h6>
            <span class="text-muted text-small">{{
              conversation.created_at
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PerfectScrollbar from "perfect-scrollbar";

export default {
  name: "chat-list",
  props: ["tb_type"],
  components: {},

  data() {
    return {
      // Side Nav Items
      conversations: [],
      chatListInterval: null
    };
  },
  methods: {
    loadChatBar() {
      const ps = new PerfectScrollbar("#scrollbar");
    },

    async loadConversations() {
      let token = localStorage.getItem("token");

      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      const header = { headers: { Authorization: "Bearer " + token } };

      const url = `/chat/conversations?tb_type=${this.tb_type}`;

      const { data } = await axios.get(url, header);
      this.conversations = data;
    },

    selectConversation(conversation) {
      this.$emit("conversationSelected", conversation);
    },

    loadNotificationBadges() {
      this.chatListInterval = setInterval(() => {
        this.loadConversations();
      }, 5 * 1000);
    }
  },
  mounted() {
    this.loadChatBar();
    this.loadConversations();
    this.loadNotificationBadges();
  },

  beforeDestroy() {
    clearInterval(this.chatListInterval);
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
